import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as ChannelsActions, Types as ChannelsTypes } from 'store/ducks/channels';

function* getChannelRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/channels/${id}`;
    const response = yield call(api.get, url);

    yield put(ChannelsActions.getChannelSuccess(response.data));
  } catch (error) {
    yield put(ChannelsActions.getChannelFailure());
  }
}

function* getChannelsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `store/v2/channels?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(ChannelsActions.getChannelsSuccess(response.data));
  } catch (error) {
    yield put(ChannelsActions.getChannelsFailure());
  }
}

function* updateChannelRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/channels/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/channels'));
    yield call(swal, 'Atualizado', 'Canal atualizado com sucesso.', 'success');
    yield put(ChannelsActions.updateChannelSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o canal.', 'error');
    yield put(ChannelsActions.updateChannelFailure());
  }
}

export default function* sagaChannels() {
  yield takeLatest(ChannelsTypes.GET_REQUEST, getChannelRequest);
  yield takeLatest(ChannelsTypes.GET_LIST_REQUEST, getChannelsRequest);
  yield takeLatest(ChannelsTypes.UPDATE_REQUEST, updateChannelRequest);
}
